import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import { SEARCH_TRADES } from "../../constant/Apipath";
import {
  Box,
  Button,
  Card,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Snackbar,
  Stack,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import SearchField from "../common/SearchField";
import { BIRed } from "../../assets/helpers";
import Loader from "../../common/Loader";
import { MoreVert as MoreIcon } from "@mui/icons-material";
import InfiniteScroll from "react-infinite-scroll-component";
import RequestTradeModal from "../common/RequestTradeModal";
import { useNavigate } from "react-router-dom";
import { setShowReport } from "../../redux/actions/actions";
import { useDispatch } from "react-redux";
import Pageheader from "../common/Pageheader";
import Emptydata from "../common/Emptydata";
import ConstructionIcon from "@mui/icons-material/Construction";
import { English } from "../../constant/EnglishFallback";
import Pages from "../../constant/ReportModel";
import AdContainer from "../common/AdContainer";

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}>
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography component="span">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const Trades = () => {
  const { loginData, multiLanguageData, reportSuccess } = useSelector((state) => state?.main);
  const ENGLISH = English.Trades || {};

  const LanguageData = multiLanguageData?.Trades || {};
  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const debounceTimeout = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [nrOfRecords, setNrOfRecords] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const [pageNr, setPageNr] = useState(1);
  const [recordId, setRecordId] = useState([]);
  const [tradeTabValue, setTradeTabValue] = useState(0);
  const [myTradesTabValue, setMyTradesTabValue] = useState("On My Profile");
  const [selectMyTradeMenu, setSelectMyTradeMenu] = useState("On My Profile");
  const [showRequestTradeModal, setShowRequestTradeModal] = useState(false);
  const [allDataLoaded, setAllDataLoaded] = useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const {
    TAB_ON_MY_PROFILE = ENGLISH.TAB_ON_MY_PROFILE,
    TEXT_FOLLOWING = ENGLISH.TEXT_FOLLOWING,
    BUTTON_REPORT = ENGLISH.BUTTON_REPORT,
    TEXT_RESULTS = ENGLISH.TEXT_RESULTS,
    TEXT_SEARCH_TRADES = ENGLISH.TEXT_SEARCH_TRADES,
    TEXT_ALL_TRADES = ENGLISH.TEXT_ALL_TRADES,
    TEXT_MY_TRADES = ENGLISH.TEXT_MY_TRADES,
    TEXT_TRADES = ENGLISH.TEXT_TRADES,
    TEXT_FIND_YOUR_TRADE = ENGLISH.TEXT_FIND_YOUR_TRADE,
    BUTTON_REQUEST_ONE = ENGLISH.BUTTON_REQUEST_ONE,
    NO_RESULT = ENGLISH.NO_RESULT,
    TEXT_THANKS_FOR_REQUESTING_A_TRADE = ENGLISH.TEXT_THANKS_FOR_REQUESTING_A_TRADE
  } = LanguageData || {};

  let myTradesArray = [
    { name: "On My Profile", value: TAB_ON_MY_PROFILE },
    { name: "Following", value: TEXT_FOLLOWING }
  ];

  useEffect(() => {
    if (reportSuccess !== true) fetchData(searchTerm, pageNr, "All");
  }, [reportSuccess]);

  const getObjectForTradeSearch = (searchTerm, pageNo, searchTypeValue) => {
    let obj = {
      UserId: Number(currentUserId),
      SearchString: searchTerm,
      MyTradeCategory: "",
      PageNumber: pageNo ?? 1,
      NrRowsPerPage: 25
    };
    if (searchTypeValue === "On My Profile") {
      return { ...obj, MyTradeCategory: "On My Profile" };
    }
    if (searchTypeValue === "Following") {
      return { ...obj, MyTradeCategory: "FOLLOWING" };
    }
    return obj;
  };

  const fetchData = async (searchTerm, pageNo, searchType) => {
    try {
      if (pageNo === 1) {
        setIsLoading(true);
      }
      setAllDataLoaded(true);
      let searchTypeValue = searchType;
      if (searchTypeValue === "check_type") {
        searchTypeValue = tradeTabValue === 0 ? "" : myTradesTabValue;
      }

      let obj = getObjectForTradeSearch(searchTerm, pageNo, searchTypeValue);

      const res = await Postrequestcall(SEARCH_TRADES, obj, loginData?.accessToken);
      const resData = res?.data?.data || [];
      let updatedData = resData.filter((value) => value != null || value != undefined);
      if (updatedData.length > 0) {
        updatedData = updatedData.sort((a, b) =>
          a.name?.trim()?.toLowerCase().localeCompare(b.name?.trim()?.toLowerCase())
        );
      }
      setData((prevData) => (pageNo === 1 ? updatedData : [...prevData, ...updatedData]));
      setNrOfRecords(res?.data?.nrOfRecords || 0);
      setAllDataLoaded(false);
      setIsLoading(false);
    } catch (error) {
      console.error("fetchData-> Error fetching data:", error);
    } finally {
      setIsLoading(false);
      setAllDataLoaded(false);
    }
  };

  const handleSearchChange = (value) => {
    setSearchTerm(value);
    clearTimeout(debounceTimeout.current);
    debounceTimeout.current = setTimeout(() => {
      fetchData(value, 1, "check_type");
    }, 1000);
  };

  const handleMenuOpen = (event, item) => {
    event.stopPropagation();
    setMoreMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => setMoreMenuAnchorEl(null);

  const handleLoadMore = async () => {
    if (data.length < nrOfRecords) {
      await fetchData(searchTerm, pageNr + 1, "check_type");
      setPageNr((prevPage) => prevPage + 1);
    }
  };

  const handleChangeTradeTab = async (event, newValue) => {
    setTradeTabValue(newValue);
    setPageNr(1);
    setSearchTerm("");
    if (newValue === 1) {
      setSelectMyTradeMenu("On My Profile");
      setMyTradesTabValue("On My Profile");
    }
    await fetchData("", 1, newValue === 0 ? "" : "On My Profile");
  };

  const handleViewReport = () => {
    setMoreMenuAnchorEl(null);
    let reportObj = {
      showReport: true,
      name: Pages?.trades?.name,
      AppScreenId: Pages?.trades?.id,
      recordId: recordId.id ?? 0
    };
    dispatch(setShowReport(reportObj));
  };

  const renderListing = () => {
    return (
      <Box className="main-content-card-list" id="scrollablediv_prodcut">
        {data.length !== 0 ? (
          <InfiniteScroll
            dataLength={data?.length}
            next={handleLoadMore}
            hasMore={data.length < nrOfRecords}
            loader={
              !allDataLoaded ? null : (
                <h4 style={{ display: "flex", justifyContent: "center" }}>
                  <Loader />
                </h4>
              )
            }
            scrollableTarget="scrollablediv_prodcut">
            <List disablePadding>
              <Stack sx={{ gap: 1 }} >
                {data?.map((item, index) => (
                  <Card
                    key={index}
                    onClick={() => {
                      navigate(`/trade/${item?.id}`);
                    }}
                    className="pagelist-content">
                    <ListItem
                      key={index}
                      secondaryAction={
                        <IconButton
                          onClick={(event) => {
                            handleMenuOpen(event, item);
                            setRecordId(item);
                          }}>
                          <MoreIcon />
                        </IconButton>
                      }
                      disablePadding>
                      <ListItemButton>
                        <ListItemText primary={item?.name} />
                      </ListItemButton>
                    </ListItem>
                  </Card>
                ))}
              </Stack>
            </List>
          </InfiniteScroll>
        ) : (
          <Box className="empty-data-card">
            <Emptydata
              icon={<ConstructionIcon className="emptydata-icon" />}
              firstText={NO_RESULT}
            />
          </Box>
        )}

        <Stack sx={{ justifyContent: "center", alignItems: "center" }} direction="column">
          <Box sx={{ display: "flex", justifyContent: "center", p: 1 }}>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              {TEXT_FIND_YOUR_TRADE}{" "}
              <Button
                sx={{ textTransform: "none" }}
                size="large"
                variant="text"
                onClick={() => {
                  setShowRequestTradeModal(true);
                }}>
                {BUTTON_REQUEST_ONE}
              </Button>
            </Typography>
          </Box>
        </Stack>
      </Box>
    );
  };

  const handleTopMenuClick = async (menuItem, params) => {
    if (params === "myTrade") {
      setMyTradesTabValue(menuItem);
      setSelectMyTradeMenu(menuItem);
    }
    setPageNr(1);
    setSearchTerm("");
    fetchData("", 1, menuItem);
  };

  return (
    <Box className="main-content-Box" sx={{ p: isSmallScreen ? 2 : 3, pt: 2 }}>
      <Pageheader headerName={TEXT_TRADES} />
      <Card className="main-content-card">
        <Grid container spacing={{ xs: 1, md: 2 }} sx={{ pb: 1,  alignItems: "center" }} >
          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
            <Tabs
              variant="fullWidth"
              aria-label="basic tabs example"
              value={tradeTabValue}
              onChange={handleChangeTradeTab}>
              <Tab label={TEXT_ALL_TRADES} {...a11yProps(0)} />
              <Tab label={TEXT_MY_TRADES} {...a11yProps(1)} />
            </Tabs>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 4 }}>
            <SearchField
              size={"small"}
              value={searchTerm}
              onChange={handleSearchChange}
              onSubmit={() => fetchData(searchTerm, 1, "check_type")}
              placeholder={TEXT_SEARCH_TRADES}
            />
          </Grid>
          <Grid sx={{ display: "flex", justifyContent: { xs: "flex-start", md: "flex-end" } }} size={{ xs: 12, sm: 12, md: 12, lg: 5 }}>
            <Typography variant="h6" sx={{ color: "text.secondary" }}>
              {nrOfRecords} {TEXT_RESULTS}
            </Typography>
          </Grid>
        </Grid>

        <TabPanel value={tradeTabValue} index={0} />
        <TabPanel value={tradeTabValue} index={1}>
          <Stack spacing={1}>
            <Divider />
            <Stack spacing={2} sx={{ pb: 1.5 }} direction={"row"}>
              {myTradesArray.map((menu, index) => {
                const isSelected = menu.name === selectMyTradeMenu;
                return (
                  <Button
                    size="large"
                    key={index}
                    label={menu.value}
                    variant={"contained"}
                    color={isSelected ? "primary" : "inherit"}
                    style={{
                      textTransform: "none",
                      borderRadius: "20px"
                    }}
                    onClick={() => handleTopMenuClick(menu.name, "myTrade")}>
                    {menu.value}
                  </Button>
                );
              })}
            </Stack>
          </Stack>
        </TabPanel>
        {isLoading ? <Loader /> : renderListing()}
          <AdContainer />
      </Card>

      {moreMenuAnchorEl && (
        <Menu
          anchorEl={moreMenuAnchorEl}
          open={Boolean(moreMenuAnchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}>
          <MenuItem
            style={{ color: BIRed }}
            dense
            onClick={() => {
              handleViewReport();
            }}>
            {BUTTON_REPORT}
          </MenuItem>
        </Menu>
      )}

      {showRequestTradeModal && (
        <RequestTradeModal
          open={showRequestTradeModal}
          onClose={() => setShowRequestTradeModal(false)}
          setSnackbarOpen={setSnackbarOpen}
        />
      )}

      {snackbarOpen && (
        <Snackbar
          open={snackbarOpen}
          onClose={() => setSnackbarOpen(false)}
          message={TEXT_THANKS_FOR_REQUESTING_A_TRADE}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          key={"bottomcenter"}
          autoHideDuration={3000}
        />
      )}

      {snackbarOpen && (
        <Snackbar
          open={snackbarOpen}
          onClose={() => setSnackbarOpen(false)}
          message={TEXT_THANKS_FOR_REQUESTING_A_TRADE}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          key={"bottomcenter"}
          autoHideDuration={3000}
        />
      )}
    </Box>
  );
};

export default Trades;

